<!-- 详情 -->
<template>
  <div>
    <application-detail></application-detail>
  </div>
</template>

<script>
// components
import ApplicationDetail from '../components/application-detail'
export default {
  name: 'mentor-zoom',
  components: {
    ApplicationDetail
  },
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
